














































































































































































































import { fetchProveedores } from './fetchProveedores';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '../../views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue'; //
import { SubAccion } from '../../views/base/VariablesPermisos';

@Component({
  components: {
    DatePicker,
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class FormCrearProveedor extends ComponenteBaseStepper {
  @Prop({ default: false }) show: boolean;
  @Prop({ default: false }) usados!: any;
  @Prop({ required: true }) usuarioActivo: any;

  esProducto: {}[] = [];
  esContrato: {}[] = [];
  esEstrategico: {}[] = [];

  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Máximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Email Inválido';
      }
    },
    rut: (value: any) => {
      if (this.formFields.internacional.value) {
        return;
      }
      let Fn = {
        // Valida el rut con su cadena completa "XXXXXXXX-X"
        validaRut: function(rutCompleto: any) {
          rutCompleto = rutCompleto.replace('‐', '-').replace(/[.]/g, '');
          if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
          var tmp = rutCompleto.split('-');
          var digv = tmp[1];
          var rut = tmp[0];
          if (digv == 'K') digv = 'k';

          return Fn.dv(rut) == digv;
        },
        dv: function(T: any) {
          var M = 0,
            S = 1;
          for (; T; T = Math.floor(T / 10))
            S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
          return S ? S - 1 : 'k';
        },
      };
      return Fn.validaRut(value) || 'Rut Invalido';
    },
  };

  formFields: {
    internacional: any;
    rut: any;
    razon: any;
    direccion: any;
    pais: any;
    telefono: any;
    contacto: any;
    email: any;
    condicion: any;
    moneda: any;
    es_producto?: Record<string, string>;
    es_contrato?: Record<string, string>;
    provee_tipo_producto?: Record<string, string>;
    es_estrategico?: Record<string, string>;
  } = {
    internacional: {
      label: 'Internacional',
      value: '',
    },
    rut: {
      label: 'RUT (Obligatorio)',
      value: '',
    },
    razon: {
      label: 'Razón Social (Obligatorio)',
      value: '',
    },
    direccion: {
      label: 'Dirección',
      value: '',
    },
    pais: {
      label: 'País',
      value: '',
    },
    telefono: {
      label: 'Teléfono',
      value: '',
    },
    contacto: {
      label: 'Contacto',
      value: '',
    },
    email: {
      label: 'Email',
      value: '',
    },
    condicion: {
      label: 'Condición',
      value: '',
    },
    moneda: {
      label: 'Moneda',
      value: '',
    },
    es_producto: {
      label: '¿Es Producto o Servicio?',
      value: '',
    },
    es_contrato: {
      label: '¿Es Contrato?',
      value: '',
    },
    provee_tipo_producto: {
      label: 'Tipo de Producto o Servicio',
      value: '',
    },
    es_estrategico: {
      label: '¿Es Estratégico o Común?',
      value: '',
    },
  };

  async crearProvee() {
    let self = this;
    if (this.formFields.rut.value != '') {
      return fetchProveedores(
        {
          rut: this.nuevoDato.rut,
          razon: this.nuevoDato.razon,
          direccion: this.nuevoDato.direccion,
          pais: this.nuevoDato.pais,
          telefono: this.nuevoDato.telefono,
          contacto: this.nuevoDato.contacto,
          email: this.nuevoDato.email,
          codicion: this.nuevoDato.condicion,
          usuarioId: this.usuarioActivo.id,
          usuarioRut: this.usuarioActivo.rut,
          internacional: this.nuevoDato.internacional,
          moneda: this.nuevoDato.moneda,
          es_producto: this.formFields.es_producto.value,
          es_contrato: this.formFields.es_contrato.value,
          provee_tipo_producto: this.formFields.provee_tipo_producto.value,
          es_estrategico: this.formFields.es_estrategico.value,
        },
        'conectaMantenedorProveedores/crear'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
            this.closeModal(false);
            return null;
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
            return [];
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Error al crear el proveedor', { timeout: 3000 });
        });
    } else {
      self.$snotify.error('Por favor ingrese un RUT valido', { timeout: 3000 });
    }
  }

  validarEmail() {
    let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    return emailRegex.test(this.nuevoDato.email);
  }

  nuevoDato: any = {};

  crear() {
    this.nuevoDato.rut = this.formFields.rut.value.toUpperCase();
    this.nuevoDato.razon = this.formFields.razon.value.toUpperCase();
    this.nuevoDato.direccion = this.formFields.direccion.value.toUpperCase();
    this.nuevoDato.pais = this.formFields.pais.value.toUpperCase();
    this.nuevoDato.internacional = this.formFields.internacional.value
      ? 'Y'
      : 'N';
    this.nuevoDato.telefono =
      this.formFields.telefono.value.length > 0
        ? '+' + this.formFields.telefono.value
        : '';
    this.nuevoDato.contacto = this.formFields.contacto.value.toUpperCase();
    this.nuevoDato.email = this.formFields.email.value.toUpperCase();
    this.nuevoDato.condicion = this.formFields.condicion.value.toUpperCase();
    this.nuevoDato.moneda = this.formFields.moneda.value.toUpperCase();
    this.nuevoDato.rut = this.nuevoDato.rut.split('.').join('');

    if (this.nuevoDato.rut == '' || this.nuevoDato.razon == '') {
      this.$snotify.error('Por favor ingrese RUT y Razón social ', {
        timeout: 3000,
      });
      return;
    }

    if (this.usados.includes(this.nuevoDato.rut)) {
      this.$snotify.error('Por favor verifique que el rut no este registrado', {
        timeout: 3000,
      });
      return;
    }

    if (this.nuevoDato.email != '' && !this.validarEmail()) {
      this.$snotify.error('Por favor verifique que el email sea valido', {
        timeout: 3000,
      });
      return;
    }

    if (this.nuevoDato.telefono.length > 16) {
      this.$snotify.error('Por favor ingrese un número de teléfono valido', {
        timeout: 3000,
      });
      return;
    }

    this.crearProvee();
  }

  monedas: Array<object> = [];
  async getMonedas() {
    let self = this;
    return fetchProveedores({}, 'conectaMantenedorProveedores/get_filters')
      .then((data: any) => {
        const {
          MENSAJE_RESPUESTA,
          CODIGO_RESPUESTA,
          MONEDAS,
          ES_PRODUCTO,
          ES_CONTRATO,
          ES_ESTRATEGICO,
        } = data.data;

        if (CODIGO_RESPUESTA == '1') {
          this.monedas = MONEDAS;
          self.esProducto = ES_PRODUCTO;
          self.esContrato = ES_CONTRATO;
          self.esEstrategico = ES_ESTRATEGICO;
        } else {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Error al cargar las monedas', { timeout: 3000 });
      });
  }

  mounted() {
    this.getMonedas();
  }

  // permisos
  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  crearProveedor: PermisoAccionVm = {
    accion: 'Crear - Crear Proveedor',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };

  asociarAcciones: PermisoAccionVm = {
    accion: 'Crear - Asociar Acciones',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 20,
  };

  asociarSubAcciones: PermisoAccionVm = {
    accion: 'Crear - Asociar SubAcciones',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 21,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.crearProveedor,
    this.asociarAcciones,
    this.asociarSubAcciones,
  ];

  // Globales
  $snotify: any;
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  validForm: boolean = false;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;

  //data
  estadosServices: EstadosService = new EstadosService();
  estados: EstadoInterface[] = this.estadosServices.getEstadosVisibles();

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  closeModal(val: boolean) {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('datoCreado', true);
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset(); //Reset Validaciones
    this.dialog = false;

    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';

    this.show = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
}
